<se-persona-avatar
  *ngIf="usePersonaAvatar"
  [se-data-identity]="identity"
  [se-data-img-url]="imageUrl"
  [se-data-border]="border"
  se-data-size="{{ size }}">
</se-persona-avatar>

<se-team-avatar
  *ngIf="useTeamAvatar"
  [attr.aria-label]="identity"
  [se-data-sport]="sport"
  [se-data-img-url]="imageUrl"
  [se-data-border]="border"
  [se-data-white]="border"
  [se-data-team-color]="teamColor"
  se-data-size="{{ size }}">
</se-team-avatar>

<se-org-avatar
  *ngIf="useOrgAvatar"
  [se-data-identity]="identity"
  [se-data-img-url]="imageUrl"
  [se-data-border]="border"
  se-data-size="{{ size }}">
</se-org-avatar>

<se-icon *ngIf="hasStatus"
  name="{{ statusIcon }}"
  [ngClass]="statusClass"
  class="se-common-avatar__status"></se-icon>
